var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompassPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_19",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m367.24507,88.16407l8.36129,8.99216c0.53504,0.57618 0.82394,1.36501 0.79722,2.17826c-0.02705,0.81362 -0.36638,1.5791 -0.93749,2.11253l-36.89055,34.45565l8.22035,8.84129c1.06608,1.14625 1.06608,3.00445 0.00033,4.15034c-0.53304,0.5733 -1.2314,0.8596 -1.92976,0.8596s-1.39672,-0.28629 -1.92943,-0.85924l-9.82147,-10.56336c-5.05919,-1.71704 -10.31944,-2.58992 -15.64749,-2.58992c-12.93387,0 -25.14433,5.06022 -34.67724,14.30779l32.75015,35.224c0.00334,0.00359 7.71804,8.30104 7.71804,8.30104c0.00401,0.00431 32.75315,35.22795 32.75315,35.22795c12.32435,-14.69753 16.47577,-35.11911 10.88955,-54.13222l-16.24666,-17.47388c-1.06574,-1.14661 -1.06574,-3.00445 0,-4.1507c1.06608,-1.14589 2.79344,-1.14589 3.85919,0l14.65188,15.75865l30.36817,-37.61133l-20.0691,-21.58471c-1.06574,-1.14661 -1.06574,-3.00445 0,-4.1507c1.06608,-1.14589 2.79344,-1.14589 3.85919,0l21.86761,23.51943l8.36062,8.99288l3.85885,-4.15034l-46.30756,-49.80551l-3.85885,4.15034l0.00001,0z",
    fill: "#0A0",
    id: "svg_1",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.6132507324219,191.50228881835938 261.97296142578125,247.04443359375 260.04315185546875,253.2695770263672 265.83111572265625,251.1940155029297 317.472412109375,195.65298461914062 ",
    fill: "#98D9D5",
    id: "svg_2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.20043,131.74407l-50.16708,-53.95585c-1.06675,-1.14661 -2.79411,-1.14589 -3.85919,0l-7.71804,8.30104c-1.06574,1.14661 -1.06574,3.00445 0,4.1507l8.22102,8.84093l-35.73897,33.38053c-5.33807,-1.71811 -10.87118,-2.58812 -16.46976,-2.58812c-15.30482,0 -29.69352,6.4105 -40.51528,18.04934c-1.06574,1.14661 -1.06574,3.00445 0,4.1507l32.80091,35.2786l-52.09618,56.03138c-0.29958,0.32257 -0.52502,0.71483 -0.65928,1.14732l-3.85885,12.45102c-0.32664,1.05465 -0.07181,2.21742 0.65928,3.00373c0.52001,0.55929 1.21737,0.85924 1.92976,0.85924c0.28856,0 0.5798,-0.04921 0.86268,-0.15051l11.57656,-4.15034c0.40178,-0.14404 0.76649,-0.38651 1.06675,-0.70909l52.09618,-56.03102l32.80091,35.2786c0.53304,0.57294 1.23107,0.85924 1.92976,0.85924c0.69803,0 1.39672,-0.28629 1.92976,-0.85924c7.64256,-8.21986 12.94723,-18.52745 15.34089,-29.80816c2.21131,-10.42326 1.87398,-21.27076 -0.96555,-31.48137l31.03614,-38.43859l8.22035,8.84165c1.06608,1.14589 2.79344,1.14481 3.85919,0l7.71804,-8.30104c1.06541,-1.14625 1.06541,-3.00409 0,-4.1507l0,0.00001zm-9.64746,6.22623l-8.36062,-8.99288l-21.86761,-23.51943c-1.06608,-1.14589 -2.79344,-1.14589 -3.85919,0c-1.06574,1.14661 -1.06574,3.00445 0,4.1507l20.0691,21.58471l-30.36817,37.61133l-14.65188,-15.75865c-1.06608,-1.14589 -2.79344,-1.14589 -3.85919,0c-1.06574,1.14661 -1.06574,3.00445 0,4.1507l16.24666,17.47388c5.58622,19.01311 1.4348,39.43433 -10.88922,54.13222l-32.74948,-35.22364c-0.00401,-0.00431 -7.71871,-8.30176 -7.71871,-8.30176c-0.00334,-0.00359 -32.75315,-35.2276 -32.75315,-35.2276c9.53257,-9.24828 21.74337,-14.30779 34.67724,-14.30779c5.32838,0 10.5883,0.87289 15.64749,2.58992l9.82147,10.56336c0.5327,0.57294 1.23107,0.85924 1.92943,0.85924c0.69803,0 1.39672,-0.28629 1.92976,-0.8596c1.06574,-1.14625 1.06574,-3.00445 -0.00033,-4.15034l-8.22035,-8.84129l36.89055,-34.45565c0.57111,-0.53379 0.91111,-1.29927 0.93749,-2.11253c0.02672,-0.81362 -0.26218,-1.60281 -0.79722,-2.17826l-8.36129,-8.99216l3.85885,-4.15034l46.30823,49.80587l-3.85985,4.14998l-0.00001,0.00001zm-153.50978,115.29926l1.92976,-6.22551l51.64062,-55.54213l3.85885,4.15034l-51.64129,55.54177l-5.78794,2.07553z",
    fill: "#082947",
    id: "svg_3",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_4",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_5",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_6",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_7",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_8",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_9",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_10",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_11",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_12",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_13",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_14",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_15",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_16",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_17",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_18",
    stroke: "null"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassPin);
export default __webpack_public_path__ + "static/media/compass_pin.3bfe684cad39f3bf0e592dec14a9b8a8.svg";
export { ForwardRef as ReactComponent };